import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Alert,
  Divider,
  Paper,
  Stack
} from '@mui/material';

import SchoolIcon from '@mui/icons-material/School';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import AssignmentIcon from '@mui/icons-material/Assignment';

import { useParams } from 'react-router-dom';
import axiosInstance from '../../api/axiosConfig';


const ApplyOnline = () => {
  const { courseId } = useParams();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [course, setCourse] = useState(null);
  const [branches, setBranches] = useState([]);

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState('');
  const [utrNumber, setUtrNumber] = useState('');
const [paymentLoading, setPaymentLoading] = useState(false);
const [paymentSubmitted, setPaymentSubmitted] = useState(false);
  

  const [formData, setFormData] = useState({
    fullName: '',
    fatherName: '',
    motherName: '',
    dob: '',
    gender: '',
    mobile: '',
    email: '',
    address: '',
    aadhaarNumber: '',
    qualification: '',
    branchId: '',
    courseId: parseInt(courseId)
  });

  useEffect(() => {
    loadPageData();
  }, [courseId]);

  const loadPageData = async () => {
    try {
      setLoading(true);

      const [courseResponse, branchResponse] =
        await Promise.all([
          axiosInstance.get(`/courses/${courseId}`),
          axiosInstance.get('/branch/active')
        ]);

      setCourse(courseResponse.data);

      const branchData =
        branchResponse.data?.data ||
        branchResponse.data ||
        [];

      setBranches(Array.isArray(branchData) ? branchData : []);
    }
    catch (err) {
      console.error(err);
      setError('Failed to load admission form');
    }
    finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    if (!formData.fullName.trim())
      return 'Full Name is required';

    if (!formData.mobile.trim())
      return 'Mobile Number is required';

    if (!formData.branchId)
      return 'Please select a branch';

    if (!formData.qualification)
      return 'Please select qualification';

    return '';
  };

  const handleSubmit = async () => {
    try {
      const validationError = validateForm();

      if (validationError) {
        setError(validationError);
        return;
      }

      setSaving(true);
      setError('');

      const payload = {
        ...formData,
        branchId: parseInt(formData.branchId),
        courseId: parseInt(courseId)
      };

      const response =
        await axiosInstance.post(
          '/admission',
          payload
        );

      setSuccess(response.data);
    }
    catch (err) {
      console.error(err);

      setError(
        err.response?.data?.message ||
        'Failed to submit application'
      );
    }
    finally {
      setSaving(false);
    }
  };
const handlePaymentSubmit = async () => {
  try {

    if (!utrNumber.trim()) {
      setError('Please enter UTR Number');
      return;
    }

    setPaymentLoading(true);

    await axiosInstance.post(
      `/admission/${success.applicationId}/submit-payment`,
      {
        paymentReference: utrNumber
      }
    );

    setPaymentSubmitted(true);

  } catch (err) {

    console.error(err);

    setError(
      err.response?.data ||
      'Failed to submit payment details'
    );

  } finally {

    setPaymentLoading(false);

  }
};
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress size={50} />
      </Box>
    );
  }

  if (success) {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>

      <Alert severity="success" sx={{ mb: 3 }}>
        Admission Application Submitted Successfully
      </Alert>

      <Card
        sx={{
          borderRadius: 4,
          boxShadow: 5
        }}
      >
        <CardContent sx={{ p: 4 }}>

          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
          >
            Application Submitted
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6">
            Application Number
          </Typography>

          <Typography
            variant="h3"
            color="primary"
            fontWeight="bold"
            mb={3}
          >
            {success.applicationNumber}
          </Typography>

          <Typography sx={{ mb: 1 }}>
            <strong>Application Status:</strong>
            {' '}
            Pending
          </Typography>

          <Typography sx={{ mb: 3 }}>
            <strong>Payment Status:</strong>
            {' '}
            {paymentSubmitted
              ? 'Submitted'
              : 'Pending'}
          </Typography>

          <Alert
            severity="warning"
            sx={{ mb: 3 }}
          >
            Please pay the admission fee and
            submit the UTR number below.
          </Alert>

          <Typography
            variant="h5"
            color="success.main"
            fontWeight="bold"
            textAlign="center"
            mb={3}
          >
            Admission Fee: ₹
            {success.admissionFee?.toLocaleString()}
          </Typography>

          {/* QR CODE */}
 
          <Box textAlign="center" mb={3}>
            <Typography
              variant="h6"
              gutterBottom
            >
              Scan QR Code & Pay
            </Typography>

            <img
              src="/paymentqr.jpeg"
              alt="Payment QR"
              style={{
                maxWidth: '300px',
                width: '100%',
                borderRadius: '12px'
              }}
            />
          </Box>

          {/* UTR INPUT */}

          {!paymentSubmitted && (
            <>
              <TextField
                fullWidth
                label="Enter UTR / Transaction Number"
                value={utrNumber}
                onChange={(e) =>
                  setUtrNumber(e.target.value)
                }
                sx={{ mb: 3 }}
              />

              <Button
                fullWidth
                variant="contained"
                color="success"
                size="large"
                onClick={handlePaymentSubmit}
                disabled={paymentLoading}
              >
                {paymentLoading
                  ? 'Submitting...'
                  : 'Submit Payment Details'}
              </Button>
            </>
          )}

          {paymentSubmitted && (
            <Alert
              severity="success"
              sx={{ mt: 3 }}
            >
              Payment details submitted successfully.
              Our team will verify the payment and
              update the status shortly.
            </Alert>
          )}

        </CardContent>
      </Card>

    </Container>
  );
}

  return (
    <Box
      sx={{
        py: 6,
        background:
          'linear-gradient(to right,#f8fbff,#eef5ff)',
        minHeight: '100vh'
      }}
    >
      <Container maxWidth="lg">

        <Typography
          variant="h3"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
        >
          Online Admission Form
        </Typography>

        <Typography
          textAlign="center"
          color="text.secondary"
          mb={4}
        >
          Complete the admission form below
          and submit your application.
        </Typography>

        {error && (
          <Alert
            severity="error"
            sx={{ mb: 3 }}
          >
            {error}
          </Alert>
        )}

        {/* COURSE CARD */}

        <Card
          sx={{
            mb: 4,
            borderRadius: 4,
            boxShadow: 3
          }}
        >
          <CardContent>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
            >
              <SchoolIcon
                color="primary"
                fontSize="large"
              />

              <Box>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                >
                  Selected Course
                </Typography>

                <Typography>
                  {course?.courseName}
                </Typography>

                <Typography
                  color="text.secondary"
                >
                  Duration:
                  {' '}
                  {course?.durationMonths}
                  {' '}
                  Months
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        {/* FORM STARTS */}

        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 4
          }}
        >
          <Grid container spacing={3}>
                        {/* Full Name */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Full Name"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
              />
            </Grid>

            {/* Mobile */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
              />
            </Grid>

            {/* Father Name */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Father Name"
                name="fatherName"
                value={formData.fatherName}
                onChange={handleChange}
              />
            </Grid>

            {/* Mother Name */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Mother Name"
                name="motherName"
                value={formData.motherName}
                onChange={handleChange}
              />
            </Grid>

            {/* DOB */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="date"
                label="Date of Birth"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Gender */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Gender</InputLabel>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  label="Gender"
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Email */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Grid>

            {/* Qualification */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Qualification</InputLabel>
                <Select
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleChange}
                  label="Qualification"
                >
                  <MenuItem value="10th">10th Pass</MenuItem>
                  <MenuItem value="12th">12th Pass</MenuItem>
                  <MenuItem value="ITI">ITI</MenuItem>
                  <MenuItem value="Diploma">Diploma</MenuItem>
                  <MenuItem value="Graduate">Graduate</MenuItem>
                  <MenuItem value="Post Graduate">Post Graduate</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Branch */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Select Branch</InputLabel>
                <Select
                  name="branchId"
                  value={formData.branchId}
                  onChange={handleChange}
                  label="Select Branch"
                >
                  {branches.map((branch) => (
                    <MenuItem
                      key={branch.branchId}
                      value={branch.branchId}
                    >
                      {branch.branchName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Aadhaar */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Aadhaar Number"
                name="aadhaarNumber"
                value={formData.aadhaarNumber}
                onChange={handleChange}
              />
            </Grid>

            {/* Address */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                multiline
                rows={4}
                label="Full Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </Grid>

            {/* Information Card */}
            <Grid item xs={12}>
              <Card
                sx={{
                  bgcolor: '#f8f9fa',
                  borderRadius: 3,
                  border: '1px solid #e0e0e0'
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Admission Information
                  </Typography>

                  <Typography variant="body2">
                    • Please ensure all details are correct.
                  </Typography>

                  <Typography variant="body2">
                    • After submission, an Application Number will be generated.
                  </Typography>

                  <Typography variant="body2">
                    • Payment will be completed in the next step.
                  </Typography>

                  <Typography variant="body2">
                    • Admission approval is subject to document verification.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                fullWidth
                size="large"
                variant="contained"
                onClick={handleSubmit}
                disabled={saving}
                sx={{
                  py: 1.8,
                  fontSize: '1rem',
                  fontWeight: 700,
                  borderRadius: 3
                }}
              >
                {saving ? (
                  <CircularProgress
                    size={24}
                    color="inherit"
                  />
                ) : (
                  'Submit Admission Application'
                )}
              </Button>
            </Grid>

          </Grid>
        </Paper>

      </Container>
    </Box>
  );
};

export default ApplyOnline;